import type { MemberRow } from '../apiClient/types.gen';

// gloss
export type JoinSource = NonNullable<MemberRow['joinSource']>;

// gloss
export const JOIN_SOURCE_LABELS: Record<JoinSource, string> = {
  sso: 'Single sign-on',
  password: 'Signed up directly',
  otp: 'Email verification',
  invite_link: 'Invite link',
  email_link: 'Email link',
  embed: 'Embedded widget',
  application_approval: 'Application approved',
  admin: 'Added by an admin',
  api: 'Added via API',
  bulk_import: 'Bulk import',
  csv_import: 'File import',
  reference_opt_in_import: 'Reference opt-in import',
  integration: 'Integration',
};

// gloss
export const JOIN_SOURCE_UNKNOWN_LABEL = 'Not recorded';
